<template>  
  <v-app id="app" :style="{'background-image':'url(https://aatgeniemedia.blob.core.windows.net/assets/web/ambient-bubbles-faint.png)'}">
    <app-toolbar />
    <v-main>
      <app-breadcrumbs />
      <router-view />
    </v-main>
    <app-footer />
    <app-confirm />
    <app-error />
    <app-alert />
    <app-upload />
    <app-user />
    <app-resident />
    <app-kiosk />
    <app-message />
    <app-media />
  </v-app>
</template>

<script>

import AppToolbar from '@/components/App/AppToolbar'
import AppBreadcrumbs from '@/components/App/AppBreadcrumbs'
import AppFooter from '@/components/App/AppFooter'

export default {
  name: 'App',
  components: {
    AppToolbar,
    AppBreadcrumbs,
    AppFooter
  },
  computed: {
    backgroundColor () {
      return this.$route.name === 'Home'
        ? this.appColor_BackgroundHome
        : this.appColor_Background
    } 
  },
  mounted() {
    window.onpopstate = () => {
      this.$alert.show({
        text: this.getExpression('Alert', 'BrowserBackButtonWarning')
      })
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
